import useSetProjectId from '@activities/MainActivity/hooks/useSetProjectId';
import queries from '@apis/queries';
import Button from '@components/Button';
import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import Image from '@components/Image';
import Row from '@components/Row';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

const LinkActivity: ActivityComponentType = () => {
    const { t } = useTranslation('link');
    const { main } = useAppCustom();
    const isIos = !(navigator.userAgent.match(/iPhone|iPad|iPod/i) === null);
    useSetProjectId();
    const { data: versionInfo } = useQuery(queries.version.check({
        appType: 'ORDER',
        version: '0',
        osType: isIos ? 'IOS' : 'AOS',
    }));

    const openStore = () => {
        const iosUrl = 'https://apps.apple.com/us/app/%ED%94%BC%EC%97%90%EC%8A%A4%ED%83%807/id6754587894';
        const androidUrl = 'https://play.google.com/store/apps/details?id=co.kr.waldlust.fiesta7';
        if (versionInfo?.storeUrl) {
            window.location.href = versionInfo.storeUrl;
        } else if (isIos) {
            window.location.href = iosUrl;
        } else {
            window.location.href = androidUrl;
        }
    };

    const openApp = () => {
        if (versionInfo?.appScheme) {
            window.location.href = versionInfo?.appScheme;
        } else {
            window.location.href = 'fiesta7://';
        }
    };
    return (
        <AppScreen>
            <Container>
                <LogoWrapper>
                    <Image src={main.logo}/>
                </LogoWrapper>
                <Column fullWidth spacing={12}>
                    <Button variant='secondary' fullWidth onClick={openApp} noPadding >
                        {t('openApp')}
                    </Button>
                    <Button fullWidth onClick={openStore} noPadding >
                        {t('installApp')}
                    </Button>
                </Column>
            </Container>
        </AppScreen>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    row-gap: 80px;
    padding: 0 20px;
`;

const LogoWrapper = styled.div`
    flex: 1;
    padding-top: 80px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
        max-width: calc(100% - 20px);
    };
`;

export default LinkActivity;
